<div class="main-layout">
  <brt-layout-header />
  <main>
    @if(!fullWidth() && !hq && !(hideBanner() && business)){
    <div class="main-banner">
      <picture>
        <source [srcset]="bannerSrc()" type="image/jpeg" />
        <img class="tw-w-full tw-max-h-[50vh] tw-object-cover" [src]="bannerSrc()" alt="banner" />
      </picture>
    </div>
    }
    @if(fullWidth()){
    <router-outlet/>
    } @else {
    <div class="tw-container tw-pb-8 lg:tw-px-4">
      <router-outlet/>
    </div>
    }
  </main>
  <brt-footer class="tw-mt-auto" />
</div>
